const styles = {
  linkButton: {
    backgroundColor: '#084D2C',
    color: '#B6F2D6',
    flexBasis: '25%',
    fontSize: '11px',
    fontWeight: 'bold',
    cursor: 'pointer',
    clear: 'both',
    textTransform: 'uppercase',
    textAlign: 'center',
    padding: '0 20px',
    boxSizing: 'border-box',
    lineHeight: '40px',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectListFooterLink/ProjectListFooterLink.styles.js